import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AttendanceService {

  constructor(private http: HttpClient) { }

  //CalenderDayType
  getAllAttendanceType() {
    return this.http.get<any>(
      `${environment.API_URL_ADM}/api/atnattendancetypes`);
  }

  addAttendanceType(username: string, orgid: any, attCode: string, attNameAr: string, attNameEn: string, active: string,attFactor:any) {

    return this.http.post<any>(
      `${environment.API_URL_ADM}/api/atnattendancetypes/${username}`, { orgid, attCode, attNameAr, attNameEn,active,attFactor });
  }
  updateAttendanceType(username: string, id: any, orgid: any, attCode: string, attNameAr: string, attNameEn: string, active: string,attFactor:any) {
    return this.http.put<any>(
      `${environment.API_URL_ADM}/api/atnattendancetypes/${username}/${id}`, { id, orgid, attCode, attNameAr, attNameEn,active ,attFactor});
  }


  getAttendanceTypeById(id: any) {
    return this.http.get<any>(
      `${environment.API_URL_ADM}/api/atnattendancetypes/${id}`);
  }

  getBatchGroups(orgid: any, batchId: any) {
    return this.http.get<any>(
      `${environment.API_URL_ADM}/api/erlgroupbygrade/${orgid}/${batchId}`);
  }

  getAttendanceStatuses(orgid: any) {
    return this.http.get<any>(
      `${environment.API_URL_ADM}/api/attendancetypesfu/${orgid}`);
  }

  getStudentsAttendanceRequest(orgid: any, yearid:any, semesterid: any, batchid:any, groupid: any, dayDate: any) {
    return this.http.get<any>(
      `${environment.API_URL_ADM}/api/atnattendancedaysfiltered/${orgid}/${yearid}/${semesterid}/${batchid}/${groupid}/${dayDate}`);
  }

  updateStatusAndCommentForAttendance(username:string,id:any,atntypeid:any,statusFlag:string,remarks:string){
    return this.http.put<any>(
      `${environment.API_URL_ADM}/api/atnattendancedaysfu/${username}/${id}`, { id, atntypeid, statusFlag, remarks});

  }

  updateStatusAndCommentForAttendanceBulk(username:string, data: any[]){
    return this.http.put<any>(
      `${environment.API_URL_ADM}/api/atnattendancedaysfuBulk/${username}`, data);
  }

  getDateStatusByGroup(orgid: any, yearid:any, semesterid: any, batchid:any, groupid: any) {
    return this.http.get<any>(
      `${environment.API_URL_ADM}/api/attendancedays/${orgid}/${yearid}/${semesterid}/${batchid}/${groupid}`);
  }


  getStudentsByGroup(orgid: any, yearid:any, semesterid: any,  groupid: any) {
    return this.http.get<any>(
      `${environment.API_URL_ADM}/api/stustudentbygroup/${orgid}/${yearid}/${semesterid}/${groupid}`);
  }

  generateEligibleExamReport(orgid: any, yearid:any, semesterid: any,  groupid: any, studentid: any, lang: any, username: any, batchId: any) {
    return this.http.get<any>(
      `${environment.API_URL_ADM}/api/generatereport400/${orgid}/${yearid}/${semesterid}/${groupid}/${studentid}/${lang}/${username}/${batchId}`);
  }

  getEligibleExamReport(username: any) {
    let reportId = 400;
    return this.http.get<any>(
      `${environment.API_URL_ADM}/api/schmatrixbyrepid/${username}/${reportId}`);
  }

  
  getStudentsAttendanceSummary(orgid: any, yearid:any, semesterid: any, batchid:any, groupid: any, dayDate: any) {
    return this.http.get<any>(
      `${environment.API_URL_ADM}/api/atnattendancesummaryvw/${orgid}/${yearid}/${semesterid}/${batchid}/${groupid}/${dayDate}`);
    // return this.http.get<any>(
    //   `${environment.API_URL_ADM}/api/atnattendancesummaryvw/10/2021/20211/102/420/2022-04-17`);
  }


  //get absence types 
  getAbscenceTypes(orgid: any) {
    return this.http.get<any>(
      `${environment.API_URL_ADM}/api/attendancetypesfr/${orgid}`);
  }

  //get students by User 
  getStudentsByUser(orgid: any, userName:any, studentid: any) {
    return this.http.get<any>(
      `${environment.API_URL_ADM}/api/stustudentbyuser/${orgid}/${userName}/${studentid}`);
  }

  //get students VW by User 
  getStudentsVWByUser(orgid: any, userName:any, studentid: any) {
    return this.http.get<any>(
      `${environment.API_URL_ADM}/api/atnattendancerequestsvw/${orgid}/${userName}/${studentid}`);
  }

  //add abscence request
  addAbscenceRequest(username: string, orgid: any, yearid: any, semesterid: any, studentid: any,atntypeid:any,dateFrom:any,dateTo:any,daysNo:any,remarks:any,statusFlag:any,attachmentFilename:any, active: string) {

    return this.http.post<any>(
      `${environment.API_URL_ADM}/api/atnattendancerequests/${username}`, { orgid, yearid, semesterid, studentid,atntypeid,dateFrom,dateTo,daysNo,remarks,statusFlag,attachmentFilename,active });
  }

  getAbscenceRequestById(id: number) {
    return this.http.get<any>(
      `${environment.API_URL_ADM}/api/atnattendancerequests/${id}`);
  }

  updateAbscenceRequest(id:any, username: string, orgid: any, yearid: any, semesterid: any, studentid: any,atntypeid:any,dateFrom:any,dateTo:any,daysNo:any,remarks:any,statusFlag:any,attachmentFilename:any, active: string) {

    return this.http.put<any>(
      `${environment.API_URL_ADM}/api/atnattendancerequests/${username}/${id}`, { id, orgid, yearid, semesterid, studentid,atntypeid,dateFrom,dateTo,daysNo,remarks,statusFlag,attachmentFilename,active });
  }

  //
  getDateStatusByYearSemesterBatchGroup(orgid: any, yearid:any, semesterid: any, batchid:any,grpid:any) {
    return this.http.get<any>(
      `${environment.API_URL_ADM}/api/atnattendancedayshdr/${orgid}/${yearid}/${semesterid}/${batchid}/${grpid}`);
  }

  getDateShById(id:any) {
    return this.http.get<any>(
      `${environment.API_URL_ADM}/api/atnattendancedayshdr/${id}`);
  }

  UpdateDateShById(username:string,id:any,dataToUpdate:any) {
    return this.http.put<any>(
      `${environment.API_URL_ADM}/api/atnattendancedayshdr/${username}/${id}`, { ...dataToUpdate });
  }

  DeleteDateShById(username:string,id:any) {
    return this.http.delete<any>(
      `${environment.API_URL_ADM}/api/atnattendancedayshdr/${username}/${id}`);
  }
  AddDateSh(username:string,dataToAdd:any) {
    return this.http.post<any>(
      `${environment.API_URL_ADM}/api/atnattendancedayshdr/${username}`,{...dataToAdd});
  }

}
